import { useContext, useEffect, useState } from 'react'
import { Card, CardBody, IconButton, Checkbox, Spinner } from "@material-tailwind/react";
import { BiEdit } from 'react-icons/bi';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css'
import { get_style_data, update_style_priority } from '../../Controller/actions';
import { NewContext } from '../../Context/NewContext';
import { RiDeleteBinLine } from 'react-icons/ri';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Pagination } from './../../Components/Pagination/Pagination';
import { SearchAndAddBtn } from './../../Components/SearchAndAddBtn/SearchAndAddBtn';
import Switch from '../../Components/Switch/Switch';
import { THead } from './../../Components/Table/THead';
import StyleModel from '../../Components/Modals/StyleModel';
import AnimationComponent from '../AnimationComponent/AnimationComponent';


const Style = ({ title }) => {
    const { permissions, tokenType, infoData, setDeleteUpdateTag, setDeleteUpdateItem, setAddEditDeleteTag, setFormData, confirmationModalShow, setConfirmationModalShow, handleSwitchUpdate, isLoading, deleteUpdateTag, checkedValues, handleCheckboxChange, currentPage, totalPage, perPage, search, setDeleteUpdateYes, setIsLoading, setCurrentPage, setPerPage, setTotalPage, currentPageData, setCurrentPageData, filterDropdown, handleOpen, isAscending, sortData } = useContext(NewContext);
    const simpleFields = [
        { name: "Preview", },
        { name: "Style Name", field: 'name' },
        { name: "Style ", field: 'name' },
        { name: "User Hit", sortable: true, field: 'userHit' },
    ];
    const [pagePermissions, setPagePermissions] = useState({
        CU: true,
        R: true,
        D: true
    });
    const dropdownFields = [{ name: "Active" }, { name: "Top" }, { name: "Latest" }, { name: "Premium" },];
    const totalFields = simpleFields.length + dropdownFields.length + 2;

    const getStyleData = async (_currentPage = 1, sortName = sortData, sortType = isAscending) => {
        setIsLoading(true);
        try {
            const getStyleData = await get_style_data(_currentPage, perPage, search, filterDropdown, sortName, sortType);
            if (getStyleData) {
                const { status, data, currentPage, perPage, totalPage } = getStyleData;
                if (status) {
                    setCurrentPageData(data);
                    setCurrentPage(currentPage);
                    setPerPage(perPage);
                    setTotalPage(totalPage || 1);
                } else {
                    setCurrentPageData([]);
                }
            }
        } catch (error) {
            console.error(error);
        }
        setIsLoading(false);
    }

    useEffect(() => {
        getStyleData(currentPage, sortData, isAscending);
        setDeleteUpdateTag("");
    }, [deleteUpdateTag, search, currentPage, perPage, filterDropdown, sortData, isAscending]);

    useEffect(() => {
        if (tokenType === 'ldap') {
            const update = permissions?.subPermissions?.find((route) => route.name === 'Style');
            setPagePermissions({ ...pagePermissions, CU: update?.CU, R: update?.R, D: update?.D })
        }
    }, [tokenType, permissions])
    const infoFile = Array.isArray(infoData) ? infoData.find(item => item.keyRoute === 'Style')?.infoFile : null;

    const handleOnDragEnd = async (result) => {
        if (!result.destination) {
            return;
        }
        const { source, destination } = result;
        if (source.index === destination.index) {
            return;
        }
        const newData = Array.from(currentPageData);
        const [movedItem] = newData.splice(source.index, 1);
        newData.splice(destination.index, 0, movedItem);
        const updateStylePriority = newData?.map((item, index) => ({
            _id: item?._id,
            priority: index + 1,
        }));
        setCurrentPageData(newData);
        try {
            await update_style_priority({ updates: updateStylePriority });
        } catch (error) {
            console.error("Error updating cross Platform priorities:", error);
        }
    };

    useEffect(() => {
        document.title = title;
    }, [title])

    return (
        <>
            <SearchAndAddBtn title={`Style`} infoFile={`${infoFile}`} countryFilter={false} addBtn={pagePermissions?.CU} countryFilter={false} deleteUpdateTag='all-delete-style' resetFilterBtn={false} />
            <Card className="overflow-hidden w-full rounded-md shadow-none">
                <CardBody className="overflow-x-auto w-100 py-2.5 px-[5px] card-body-scrollbar">
                    <DragDropContext onDragEnd={handleOnDragEnd}>
                        <Droppable droppableId="droppable" direction="vertical">
                            {(provided) => (
                                <table className="w-full min-w-max table-auto text-left"
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                >
                                    <THead simpleFields={simpleFields} dropdownFields={dropdownFields} />
                                    <tbody>
                                        {isLoading ? (
                                            <tr>
                                                <td colSpan={totalFields} className='py-12'>
                                                    <div className="flex justify-center items-center">
                                                        <Spinner />
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : currentPageData?.length === 0 ? (
                                            <tr>
                                                <td colSpan={totalFields} className='py-12 bg-gray-200'>
                                                    <div className="flex justify-center items-center">
                                                        No Data Found
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : (
                                            currentPageData?.map((_ele, i) => {
                                                const isLast = i === currentPageData?.length - 1;
                                                const classes = `text-[#1E1627] ${isLast ? "p-4" : "p-[14.5px]"}`;

                                                return (
                                                    <Draggable key={_ele._id} draggableId={_ele._id} index={i}>
                                                        {(provided) => (
                                                            <tr
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                className='border-b border-blue-gray-50'
                                                            >
                                                                <td className={classes}>
                                                                    <Checkbox
                                                                        className='w-[18px] h-[18px] border-[1.5px] rounded-[3.6px] border-[#1E3354] checked:bg-[#0047FF] checked:border-transparent'
                                                                        id={`slider-${_ele._id}`}
                                                                        value={`${_ele._id}`}
                                                                        disabled={!pagePermissions?.CU}
                                                                        checked={checkedValues.includes(`${_ele._id}`)}
                                                                        onChange={() => handleCheckboxChange(`${_ele._id}`)}
                                                                    />
                                                                </td>

                                                                <td className={`text-[#1E1627] `}>
                                                                    <div className='imgTd relative'>
                                                                        {_ele.stylePreview?.includes('json') && _ele?.viewType === 'lottie' ? (
                                                                            <AnimationComponent url={_ele?.stylePreview} style={true} />
                                                                        ) : (
                                                                            <>
                                                                                <div className="imgTd relative w-[55px]">                                                                                    <img
                                                                                    src={_ele.stylePreview || `../../../assets/images/no-image.png`}
                                                                                    alt={_ele.styleName}
                                                                                    className="absolute inset-0 h-[55px] w-full rounded-lg opacity-50"
                                                                                />
                                                                                    <Zoom>
                                                                                        <img
                                                                                            src={_ele.stylePreview || `../../../assets/images/no-image.png`}
                                                                                            alt={_ele.styleName}
                                                                                            className="relative h-[55px] w-full rounded-lg"
                                                                                        />
                                                                                    </Zoom>
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                                <td className={classes}>
                                                                    <div className="flex items-center w-40 truncate">
                                                                        <span className={`font-normal text-[17px] !w-25 overflow-hidden text-ellipsis whitespace-nowrap ${!_ele.styleName && `text-gray-500`}`}>
                                                                            {_ele.styleName || `None`}
                                                                        </span>
                                                                    </div>
                                                                </td>
                                                                <td className={classes}>
                                                                    <div className="flex items-center w-40 truncate">
                                                                        <span className={`font-normal text-[17px] !w-25 overflow-hidden text-ellipsis whitespace-nowrap ${!_ele.style && `text-gray-500`}`}>
                                                                            {_ele.style || `None`}
                                                                        </span>
                                                                    </div>
                                                                </td>

                                                                <td className={classes}>
                                                                    <div className="flex items-center w-40 truncate">
                                                                        <span className={`font-normal text-[17px] !w-25 overflow-hidden text-ellipsis whitespace-nowrap ${!_ele.userHit && `text-gray-500`}`}>
                                                                            {_ele.userHit || `0`}
                                                                        </span>
                                                                    </div>
                                                                </td>
                                                                {["isActive", "isTop", "isLatest", "isPremium"].map((_is_ele, i) => (
                                                                    <td className={classes} key={i}>
                                                                        <div className="ml-1">
                                                                            <Switch disabled={!pagePermissions?.CU} id={_ele._id} name={_is_ele} onChange={(e) => { setDeleteUpdateYes("update-style"); handleSwitchUpdate(e); }} checked={_ele[_is_ele]} />
                                                                        </div>
                                                                    </td>
                                                                ))}
                                                                <td className={classes}>
                                                                    <div className="flex items-center gap-2">
                                                                        <IconButton className='bg-[#EAEDF3] text-[#0047FF] text-[21px] shadow-none hover:shadow-none' disabled={!pagePermissions?.CU} onClick={() => { setDeleteUpdateYes("update-style"); setAddEditDeleteTag(`update`); setFormData(_ele); handleOpen() }}>
                                                                            <BiEdit />
                                                                        </IconButton>
                                                                        <IconButton className='bg-[#EAEDF3] text-[#F62929] text-[21px] shadow-none hover:shadow-none' disabled={!pagePermissions?.D} onClick={() => { setDeleteUpdateYes("delete-style"); setDeleteUpdateItem({ id: _ele._id }); setConfirmationModalShow(!confirmationModalShow) }}>
                                                                            <RiDeleteBinLine />
                                                                        </IconButton>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </Draggable>
                                                );
                                            })
                                        )}
                                        {provided.placeholder}
                                    </tbody>
                                </table>
                            )}
                        </Droppable>
                    </DragDropContext>
                </CardBody>
            </Card>
            {totalPage > 1 && <Pagination currentPage={currentPage} totalPage={totalPage} getData={getStyleData} />}
            <StyleModel />
        </>
    )
}
Style.defaultProps = {
    title: "Ai Picture Generator | Style"
};
export default Style